import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField, Button, Card, CardContent, Typography,
  Select, MenuItem, CircularProgress, Dialog, DialogTitle,
  DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import Grid from '@mui/material/Grid2';

import FileUploadModal from '../modal/CargaArchivoModal';

const apiUrlsGrupo = process.env.REACT_APP_API_GRUPO;
const apiUrlsGuardarArchivos = process.env.REACT_APP_API_GUARDAR_ARCHIVOS;
const apiUrlsFederaciones = process.env.REACT_APP_API_FEDERACIONES;

function Reservas() {
  const initializeMiembros = () => Array.from({ length: 1 }, () => ({
    nombre: '',
    apellido: '',
    oi: '',
    dni: '',
    edad: '',
    genero: '',
    federacion_deporte: '',
    rol: '',
    tipoalojado: '',
    movilidad_reducida: '',
    domicilio: { calle: '', numero: '', cp: '', provincia: '', pais: '' },
  }));

  const [miembros, setMiembros] = useState(initializeMiembros());
  const [reservaData, setReservaData] = useState({
    fechaEntrada: '',
    fechaSalida: '',
    responsableNombre: '',
    responsableApellido: '',
    responsableOi: '',
    responsableDni: '',
    responsableEdad: '',
    responsableGenero: '',
    responsableFederacion_deporte: '',
    responsablerol: '',
    responsabletipoalojado: '',
    responsablemovilidad_reducida: '',
    responsableDomicilio: { calle: '', numero: '', cp: '', provincia: '', pais: '' },
  });

  const [federaciones, setFederaciones] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingReserva, setLoadingReserva] = useState(false);
  const [currentReservaId, setCurrentReservaId] = useState(null);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => { 
    axios.get(apiUrlsFederaciones)
      .then((response) => {
        setFederaciones(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener federaciones:', error);
      });
  }, []);

  const subirArchivo = async (file, reservaId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('reservaId', reservaId);

    try {
      const response = await axios.post(`${apiUrlsGuardarArchivos}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log('Respuesta del servidor:', response.data);
      alert(`Archivo "${file.name}" subido con éxito.`);
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      alert('Error al subir el archivo.');
    }
  };

  const handleInputChange = (index, field, value) => {
    const newMiembros = [...miembros];
    newMiembros[index][field] = value;
    setMiembros(newMiembros);
  };

  const handleAddRow = () => {
    setMiembros([...miembros, {
      nombre: '', apellido: '', oi: '', dni: '', edad: '', genero: '', federacion_deporte: '', movilidad_reducida: '', domicilio: { calle: '', numero: '', cp: '', provincia: '', pais: '' },
    }]);
  };

  const validateInputs = () => {
    const errors = [];
    if (!reservaData.fechaEntrada) errors.push('La fecha de entrada es obligatoria.');
    if (!reservaData.fechaSalida) errors.push('La fecha de salida es obligatoria.');

    if (!/^[A-Za-z\s]+$/.test(reservaData.responsableNombre)) errors.push('El nombre del responsable solo puede contener letras.');
    if (!/^[A-Za-z\s]+$/.test(reservaData.responsableApellido)) errors.push('El apellido del responsable solo puede contener letras.');
    if (!/^[A-Za-z\s]+$/.test(reservaData.responsableFederacion_deporte)) errors.push('La Federacion del responsable solo puede contener letras.');
    if (!/^\d+$/.test(reservaData.responsableDni)) errors.push('El DNI del responsable debe ser un número válido.');
    if (!/^\d+$/.test(reservaData.responsableOi)) errors.push('El OI del responsable debe ser un número válido.');
    if (!/^\d+$/.test(reservaData.responsableEdad)) errors.push('La edad del responsable debe ser un número válido.');

    miembros.forEach((miembro, index) => {
        if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/.test(miembro.nombre)) errors.push(`El nombre del miembro ${index + 1} solo puede contener letras.`);
        if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/.test(miembro.apellido)) errors.push(`El apellido del miembro ${index + 1} solo puede contener letras.`);
        if (!/^\d+$/.test(miembro.edad)) errors.push(`La edad del miembro ${index + 1} debe ser un número válido.`);
        if (!/^\d+$/.test(miembro.oi)) errors.push(`El OI del miembro ${index + 1} debe ser un número válido.`);
        if (!/^\d+$/.test(miembro.dni)) errors.push(`El DNI del miembro ${index + 1} debe ser un número válido.`);
    });

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateInputs();
    if (errors.length > 0) {
      setErrorMessages(errors);
      setErrorModalOpen(true);
      return;
    }

    const userData = localStorage.getItem('user');
    let usuarioCreadorId = null;

    if (userData) {
      try {
        const userObject = JSON.parse(userData);
        usuarioCreadorId = userObject.id;
      } catch {
        alert('Error al recuperar los datos del usuario.');
        return;
      }
    }

    if (!usuarioCreadorId) {
      alert('No se encontró un ID de usuario válido en el localStorage.');
      return;
    }

    const reservaFinal = {
      usuario_creador_id: usuarioCreadorId,
      responsable: {
        nombre: reservaData.responsableNombre,
        apellido: reservaData.responsableApellido,
        oi: reservaData.responsableOi || null,
        dni: reservaData.responsableDni || null,
        edad: reservaData.responsableEdad || null,
        genero: reservaData.responsableGenero || null,
        federacion_deporte: reservaData.responsableFederacion_deporte || null,
        rol: reservaData.responsablerol || null,
        tipoalojado: reservaData.responsabletipoalojado || null,
        movilidad_reducida: reservaData.responsablemovilidad_reducida || "No",
        domicilio: {
          calle: reservaData.responsableDomicilio.calle || null,
          numero: reservaData.responsableDomicilio.numero ? parseInt(reservaData.responsableDomicilio.numero, 10) : null,
          cp: reservaData.responsableDomicilio.cp ? parseInt(reservaData.responsableDomicilio.cp, 10) : null,
          provincia: reservaData.responsableDomicilio.provincia || null,
          pais: reservaData.responsableDomicilio.pais || null,
        },
      },
      miembros: miembros.map((miembro) => ({
        nombre: miembro.nombre || null,
        apellido: miembro.apellido || null,
        oi: miembro.oi || null,
        dni: miembro.dni || null,
        edad: miembro.edad || null,
        genero: miembro.genero || null,
        federacion_deporte: reservaData.responsableFederacion_deporte || null,
        rol: miembro.rol || null,
        tipoalojado: miembro.tipoalojado || null,
        movilidad_reducida: miembro.movilidad_reducida || null,
        domicilio: {
          calle: miembro.domicilio.calle || null,
          numero: miembro.domicilio.numero ? parseInt(miembro.domicilio.numero, 10) : null,
          cp: miembro.domicilio.cp ? parseInt(miembro.domicilio.cp, 10) : null,
          provincia: miembro.domicilio.provincia || null,
          pais: miembro.domicilio.pais || null,
        },
      })),
      fechaEntrada: reservaData.fechaEntrada,
      fechaSalida: reservaData.fechaSalida,
      horaEntrada: '10:00',
      horaSalida: '22:00',
    };

    console.log('Datos enviados al backend:', JSON.stringify(reservaFinal, null, 2));

    setLoadingReserva(true);

    try {
      console.log(apiUrlsGrupo);
      axios.post(apiUrlsGrupo, reservaFinal)  
        .then((response) => {
          const reservaIdCreada = response.data.reserva?.id;
          if (!reservaIdCreada) {
            throw new Error('No se recibió un ID de reserva del backend.');
          }
          setCurrentReservaId(reservaIdCreada);
          setIsModalOpen(true);
          setMiembros(initializeMiembros());
          setReservaData({
            fechaEntrada: '',
            fechaSalida: '',
            responsableNombre: '',
            responsableApellido: '',
            responsableOi: '',
            responsableDni: '',
            responsableEdad: '',
            responsableGenero: '',
            responsableFederacion_deporte: '',
            responsablerol: '',
            responsabletipoalojado: '',
            responsablemovilidad_reducida: '',
            responsableDomicilio: { calle: '', numero: '', cp: '', provincia: '', pais: '' },
          });
        })
        .catch((error) => {
          console.error('Error al crear la reserva:', error);
          alert('Error al crear la reserva.');
          throw new Error('Fallo en el proceso de creación de la reserva.');
        })
        .finally(() => {
          setLoadingReserva(false);
        });
    } catch (error) {
      console.error('Error global en el proceso:', error);
      alert('Ocurrió un error durante el proceso. La reserva no fue creada.');
      setLoadingReserva(false);
    }
    console.log("Objeto final:", reservaFinal);
    //console.log("Estado de reservaData:", reservaData);
  };


  if (loadingReserva) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ mt: 2 }}>
          Procesando reserva...
        </Typography>
      </div>
    );
  }


  return (
    <Grid container spacing={3} justifyContent="center" sx={{ padding: '20px' }}>
      {/* Tarjeta del Responsable del Grupo */}
      <Grid item xs={12} md={8}>
        <Card sx={{ boxShadow: 3, mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Responsable del Grupo
            </Typography>

            {/* Nombre y Apellido */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Nombre"
                  variant="outlined"
                  value={reservaData.responsableNombre}
                  onChange={(e) =>
                    setReservaData({ ...reservaData, responsableNombre: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Apellido"
                  variant="outlined"
                  value={reservaData.responsableApellido}
                  onChange={(e) =>
                    setReservaData({ ...reservaData, responsableApellido: e.target.value })
                  }
                />
              </Grid>
            </Grid>

            {/* O/I N°, DNI, Edad, Federación/Deporte */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="O/I N°"
                  variant="outlined"
                  value={reservaData.responsableOi}
                  onChange={(e) => setReservaData({ ...reservaData, responsableOi: e.target.value })}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="DNI N°"
                  variant="outlined"
                  value={reservaData.responsableDni}
                  onChange={(e) => setReservaData({ ...reservaData, responsableDni: e.target.value })}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Edad"
                  variant="outlined"
                  value={reservaData.responsableEdad}
                  onChange={(e) => setReservaData({ ...reservaData, responsableEdad: e.target.value })}
                />
              </Grid>
            </Grid>
            <Select
                  //fullWidth
                  value={reservaData.responsableGenero}
                  onChange={(e) => {
                    console.log("Seleccionaste responsableGenero:", e.target.value); // <-- agregá esto
                    setReservaData({ ...reservaData, responsableGenero: e.target.value });
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Genero</MenuItem>
                  <MenuItem value="MASCULINO">Masculino</MenuItem>
                  <MenuItem value="FEMENINO">Femenino</MenuItem>
            </Select>

            {/* Federación/Deporte, Rol y Tipo de Alojamiento */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <Select
                  fullWidth
                  value={reservaData.responsableFederacion_deporte}
                  onChange={(e) => {
                    console.log("Valor seleccionado:", e.target.value);
                    setReservaData({ ...reservaData, responsableFederacion_deporte: e.target.value });
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Federación/Deporte
                  </MenuItem>
                  {federaciones.map((fed) => (
                    <MenuItem key={fed.id} value={fed.nombre_federacion}>
                      {fed.nombre_federacion}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={3}>
                <Select
                  fullWidth
                  value={reservaData.responsablerol}
                  onChange={(e) =>
                    setReservaData({ ...reservaData, responsablerol: e.target.value })
                  }
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Rol
                  </MenuItem>
                  <MenuItem value="ATLETA">Atleta</MenuItem>
                  <MenuItem value="ENTRENADOR">Entrenador</MenuItem>
                  <MenuItem value="DELEGADO">Delegado</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={3}>
                <Select
                  fullWidth
                  value={reservaData.responsabletipoalojado}
                  onChange={(e) =>
                    setReservaData({ ...reservaData, responsabletipoalojado: e.target.value })
                  }
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Tipo de Alojamiento
                  </MenuItem>
                  <MenuItem value="PERMANENTE">Permanente</MenuItem>
                  <MenuItem value="ESPORÁDICO">Esporádico</MenuItem>
                </Select>
              </Grid>
            </Grid>
              <Grid item xs={3}>
                  <Select
                    //fullWidth
                    value={reservaData.responsablemovilidad_reducida}
                    onChange={(e) =>
                      setReservaData({ ...reservaData, responsablemovilidad_reducida: e.target.value })
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      ¿Movilidad reducida?
                    </MenuItem>
                    <MenuItem value="SI">Si</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                  </Select>
                </Grid>
            {/* Calle, Número y Código Postal */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Calle"
                  value={reservaData.responsableDomicilio.calle}
                  onChange={(e) =>
                    setReservaData({
                      ...reservaData,
                      responsableDomicilio: {
                        ...reservaData.responsableDomicilio,
                        calle: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Número"
                  value={reservaData.responsableDomicilio.numero}
                  onChange={(e) =>
                    setReservaData({
                      ...reservaData,
                      responsableDomicilio: {
                        ...reservaData.responsableDomicilio,
                        numero: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Código Postal"
                  value={reservaData.responsableDomicilio.cp}
                  onChange={(e) =>
                    setReservaData({
                      ...reservaData,
                      responsableDomicilio: {
                        ...reservaData.responsableDomicilio,
                        cp: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
            </Grid>

            {/* Provincia y País */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Provincia"
                  value={reservaData.responsableDomicilio.provincia}
                  onChange={(e) =>
                    setReservaData({
                      ...reservaData,
                      responsableDomicilio: {
                        ...reservaData.responsableDomicilio,
                        provincia: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="País"
                  value={reservaData.responsableDomicilio.pais}
                  onChange={(e) =>
                    setReservaData({
                      ...reservaData,
                      responsableDomicilio: {
                        ...reservaData.responsableDomicilio,
                        pais: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Parte derecha: Seleccionar fecha y botón de reserva */}
      <Grid item xs={12} md={6}>
        <Card sx={{ boxShadow: 3, mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Fechas de Reserva
            </Typography>
            <div>Desde</div>
            <TextField
              fullWidth
              type="date"
              value={reservaData.fechaEntrada}
              onChange={(e) => setReservaData({ ...reservaData, fechaEntrada: e.target.value })}
            />
            <div>Hasta</div>
            <TextField
              fullWidth
              type="date"
              value={reservaData.fechaSalida}
              onChange={(e) => setReservaData({ ...reservaData, fechaSalida: e.target.value })}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ mt: 2 }}
            >
              Reservar
            </Button>

            <FileUploadModal
              open={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onFileUpload={(file) => subirArchivo(file, currentReservaId)}
            />
          </CardContent>
        </Card>
      </Grid>

      {/* Miembros */}
<Grid item xs={12}>
  {miembros.map((miembro, index) => (
    <Grid container spacing={2} key={index}>
      <Grid item xs={2}>
        <TextField
          fullWidth
          label="Nombre"
          variant="outlined"
          value={miembro.nombre}
          onChange={(e) => handleInputChange(index, 'nombre', e.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          label="Apellido"
          variant="outlined"
          value={miembro.apellido}
          onChange={(e) => handleInputChange(index, 'apellido', e.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          label="O/I N°"
          variant="outlined"
          value={miembro.oi}
          onChange={(e) => handleInputChange(index, 'oi', e.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          label="DNI N°"
          variant="outlined"
          value={miembro.dni}
          onChange={(e) => handleInputChange(index, 'dni', e.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          label="Edad"
          variant="outlined"
          value={miembro.edad}
          onChange={(e) => handleInputChange(index, 'edad', e.target.value)}
        />
      </Grid>
      <Select
        //fullWidth
        value={miembro.genero || ''}
        onChange={(e) => {
          console.log(`Seleccionaste genero del miembro ${index + 1}:`, e.target.value); // <-- este
          handleInputChange(index, 'genero', e.target.value);
        }}
        displayEmpty
      >
        <MenuItem value="" disabled>Genero</MenuItem>
        <MenuItem value="MASCULINO">Masculino</MenuItem>
        <MenuItem value="FEMENINO">Femenino</MenuItem>
      </Select>



      {/* Aquí se agrupan "Federación" y "Movilidad reducida" en una misma fila */}
      <Grid container item xs={4} spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Federación Deporte seleccionado"
            value={reservaData.responsableFederacion_deporte}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Select
            fullWidth
            value={miembro?.movilidad_reducida || ""}
            onChange={(e) =>
              handleInputChange(index, 'movilidad_reducida', e.target.value)
            }
            displayEmpty
          >
            <MenuItem value="" disabled>
              ¿Movilidad reducida?
            </MenuItem>
            <MenuItem value="SI">Si</MenuItem>
            <MenuItem value="NO">No</MenuItem>
          </Select>

        </Grid>
      </Grid>
      {/* Resto de los campos para dirección, etc. */}
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Calle"
          value={miembro.domicilio.calle}
          onChange={(e) =>
            handleInputChange(index, 'domicilio', {
              ...miembro.domicilio,
              calle: e.target.value,
            })
          }
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Número"
          value={miembro.domicilio.numero}
          onChange={(e) =>
            handleInputChange(index, 'domicilio', {
              ...miembro.domicilio,
              numero: e.target.value,
            })
          }
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Código Postal"
          value={miembro.domicilio.cp}
          onChange={(e) =>
            handleInputChange(index, 'domicilio', {
              ...miembro.domicilio,
              cp: e.target.value,
            })
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Provincia"
          value={miembro.domicilio.provincia}
          onChange={(e) =>
            handleInputChange(index, 'domicilio', {
              ...miembro.domicilio,
              provincia: e.target.value,
            })
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="País"
          value={miembro.domicilio.pais}
          onChange={(e) =>
            handleInputChange(index, 'domicilio', {
              ...miembro.domicilio,
              pais: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  ))}

        <Button onClick={handleAddRow} sx={{ mt: 2 }}>
          Agregar miembro
        </Button>
      </Grid>

      {/* Modal de errores */}
      <Dialog open={errorModalOpen} onClose={() => setErrorModalOpen(false)}>
        <DialogTitle>Error en los datos</DialogTitle>
        <DialogContent>
          {errorMessages.map((msg, idx) => (
            <DialogContentText key={idx}>{msg}</DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorModalOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default Reservas;